var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimIconLargePending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 70,
    viewBox: "0 0 69 70",
    width: 69,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-230-145h1200v1509h-1200z",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f3f5",
    height: 70,
    rx: 4,
    width: 69
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 56c-1.6568542 0-3-1.3431458-3-3v-36c0-1.6568542 1.3431458-3 3-3h28c1.6568542 0 3 1.3431458 3 3v36c0 1.6568542-1.3431458 3-3 3zm4-34c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h8c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm0 16c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h17c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm0 4c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h20c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm0 4c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h15c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z",
    fill: "#adb5bd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimIconLargePending);
export default __webpack_public_path__ + "static/media/claim-icon-large-pending.d782c2ee5096f00efe1202d755bbee00.svg";
export { ForwardRef as ReactComponent };